import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/Truncate.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`The Truncate component will shorten text with an ellipsis. Always add a `}<inlineCode parentName="p">{`title`}</inlineCode>{` attribute to the truncated element so the full text remains accessible.`}</p>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <p>{`Truncate will prevent text that overflows from wrapping. The default max-width is 125px.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Truncate title="Some text with a branch-name-that-is-really-long">
  Some text with a branch-name-that-is-really-long
</Truncate>
`}</code></pre>
    <h3>{`Custom max-width`}</h3>
    <p>{`You can override the maximum width of the truncated text with the `}<inlineCode parentName="p">{`maxWidth`}</inlineCode>{` prop.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Truncate maxWidth={250} title="Some text with a branch-name-that-is-really-long">
  Some text with a branch-name-that-is-really-long
</Truncate>
`}</code></pre>
    <h3>{`Inline`}</h3>
    <p>{`You can use the `}<inlineCode parentName="p">{`inline`}</inlineCode>{` boolean prop for inline (or inline-block) elements with a fixed maximum width (default: 125px).`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Truncate as="strong" inline title="branch-name-that-is-really-long">
  Some text with a branch-name-that-is-really-long
</Truncate>
`}</code></pre>
    <h3>{`Expandable`}</h3>
    <p>{`You can use the `}<inlineCode parentName="p">{`expandable`}</inlineCode>{` boolean prop to display the truncated text on hover.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Truncate expandable title="Some text with a branch-name-that-is-really-long">
  Some text with a branch-name-that-is-really-long
</Truncate>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      